import { Map as map } from 'immutable';
const C = require("../constants");

function RecipeSelectReducer(state = map(), action) {
    switch (action.type) {
        case C.RECIPE_SELECT:
            return action.data;
        default:
            return state;
    }
}

export default RecipeSelectReducer;


// WEBPACK FOOTER //
// ./src/reducers/RecipeSelectReducer.js